import Typography from '@mui/material/Typography';

type Props = {
  /** Target of the enclosing panel's aria-labelledby. */
  id: string;
  title: string;
};

/**
 * The heading of a panel — a search box, a filter card — as opposed to a whole
 * page band, which uses SectionHeading. The colour is inherited, so the same
 * heading works on a white card and on a dark glass panel.
 */
export function PanelHeading({ id, title }: Props) {
  return (
    <Typography id={id} variant="h6" component="h2" sx={{ mb: 4 }}>
      {title}
    </Typography>
  );
}
